import React from "react";
import {
    BooleanInput,
    Create,
    CreateProps,
    NumberInput,
    required,
    SimpleForm,
    TextInput,
    useTranslate
} from 'react-admin';
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    description: {
        width: 544,
    }
  }));
  import UploadImages from '../products/UploadImages';
  

const CategoryCreate = (props: CreateProps) => {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <Create {...props}>
            <SimpleForm>
                <TextInput
                    autoFocus
                    source="name_en"
                    validate={required()}
                    label="Name English"
                />
                <TextInput
                    autoFocus
                    source="name_ar"
                    validate={required()}
                    label="Name Arabic"
                />
                <UploadImages sourceName="featured_image" multiple={false} />
                <BooleanInput  source="is_featured" />
                <BooleanInput source="active" />     
            </SimpleForm>
        </Create>
    )
}

export default CategoryCreate;

